import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            paddingTop: theme.spacing(2),
        },
    }
})

export default useStyles
